// src/components/vehicles/VehicleServiceHistory.js
import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { api, formatDate, formatCurrency } from "../../utils/api";
import { AuthContext } from "../../context/AuthContext";
import "../../css/Fleet.css";

const VehicleServiceHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useRef(null);
  const { user } = useContext(AuthContext);
  const isAdmin = user?.role === "Administrator";
  const [vehicle, setVehicle] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [vRes, sRes] = await Promise.all([
          api.get(`/vehicles/${id}`),
          api.get(`/vehicles/${id}/services`),
        ]);
        setVehicle(vRes.data);
        setServices(Array.isArray(sRes.data) ? sRes.data : []);
      } catch (err) {
        console.error(err);
        toast.current?.show({ severity: "error", summary: "Błąd", detail: "Nie udało się pobrać danych" });
      }
      setLoading(false);
    };
    load();
  }, [id]);

  const totalCost = services.reduce((sum, s) => sum + (s.cost || 0), 0);

  return (
    <div className="fleet-page fleet-animate-in">
      <Toast ref={toast} />

      <div className="fleet-page-header">
        <div>
          <Button icon="pi pi-arrow-left" className="p-button-text" style={{ marginRight: "0.5rem" }} onClick={() => navigate("/serwisy")} tooltip="Wróć do listy serwisów" />
          <h1 style={{ display: "inline" }}>
            <span className="fleet-header-icon">🛠️</span>
            Historia serwisów
            {vehicle && <> — {vehicle.brand} {vehicle.model} ({vehicle.registration_number})</>}
          </h1>
          {vehicle && (
            <p className="fleet-page-subtitle">
              {vehicle.vehicleTypeName && <>{vehicle.vehicleTypeName} · </>}
              {vehicle.companyName && <>{vehicle.companyName} · </>}
              {vehicle.driver_operator && <>Kierowca: {vehicle.driver_operator}</>}
            </p>
          )}
        </div>
      </div>

      {/* Summary */}
      <div className="fleet-stats-grid" style={{ marginBottom: "1.25rem" }}>
        <div className="fleet-stat-card fleet-stat-card--primary">
          <div className="fleet-stat-icon fleet-stat-icon--primary"><i className="pi pi-shield" /></div>
          <div className="fleet-stat-value fleet-stat-value--primary">{services.length}</div>
          <div className="fleet-stat-label">Łącznie serwisów</div>
        </div>
        {isAdmin && <div className="fleet-stat-card fleet-stat-card--danger">
          <div className="fleet-stat-icon fleet-stat-icon--danger"><i className="pi pi-wallet" /></div>
          <div className="fleet-stat-value fleet-stat-value--danger" style={{ fontSize: "1.2rem" }}>{formatCurrency(totalCost)}</div>
          <div className="fleet-stat-label">Łączny koszt</div>
        </div>}
      </div>

      {/* Table */}
      <div className="fleet-card">
        <div className="fleet-card-body--flush fleet-table">
          <DataTable
            value={services} loading={loading}
            emptyMessage="Brak serwisów dla tego pojazdu"
            responsiveLayout="stack" breakpoint="768px"
            paginator rows={20}
            sortMode="single" sortField="performed_date" sortOrder={-1}
          >
            <Column field="serviceTypeName" header="Typ serwisu" />
            <Column header="Data wykonania" body={(row) => formatDate(row.performed_date)} sortable sortField="performed_date" />
            <Column header="Ważne do" body={(row) => formatDate(row.valid_until)} />
            <Column header="Koszt" body={(row) => (
              <span style={{ fontWeight: 600 }}>{formatCurrency(row.cost)}</span>
            )} />
            <Column field="notes" header="Notatki" style={{ maxWidth: "400px" }} />
            <Column field="createdByName" header="Dodał" />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default VehicleServiceHistory;
